import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box, ButtonBase, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Tour from '../../../../models/Tour';
import TourWeek from '../../../../models/TourWeek';

interface WhatsAppReserveButtonProps {
    tourWeek: TourWeek
    tour: Tour;
}

const WhatsAppReserveButton: React.FC<WhatsAppReserveButtonProps> = ({ tourWeek, tour }) => {
    const { t } = useTranslation();
    const text = `Tour ${tour.id}%0a${tour.nightCount} ${t("tour.nights")} / ${tour.rideDayCount} ${t("tour.daysRide")}%0a${t("tour.from")}: ${tourWeek.startDate}%0a${t("tour.from")}: ${tourWeek.endDate}`;
    return (
        <ButtonBase
            sx={{
                position: "relative",
                width: { xs: "100%", md: "auto" },
                bgcolor: "background.paper",
                borderRadius: "6px",
                ":hover": {
                    backgroundColor: (theme) => theme.palette.primary.light,
                    color: "#fff"
                }
            }}
            onClick={() => window.open(`https://wa.me/38763284294?text=${text}`)}>
            <Box
                sx={{
                    borderRadius: "6px",
                    boxShadow: (theme) => theme.shadows[8],
                    width: { xs: "100%", md: "auto" },
                }}
                p={1}
                borderRadius={1}
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <WhatsAppIcon sx={{ color: "#25D366" }} />
                <Typography variant='caption' ml={0.5} fontWeight={600}>{t("tour.reserve")}</Typography>
                <Typography
                    variant='caption'
                    ml={0.5}
                    fontWeight={600}>
                    ({tour.priceWithOwnMotorcycle}/{tour.price} €)
                </Typography>
            </Box>
        </ButtonBase>
    )
}

export default WhatsAppReserveButton;